import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';
import { toast } from '../../utils/toast';
import './ToastContainer.css';

class ToastContainer extends Component {
  state = {
    toasts: [],
  };

  componentDidMount() {
    this.unsubscribe = toast.subscribe((toasts) => {
      this.setState({ toasts });
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  handleClose = (id) => {
    toast.remove(id);
  };

  render() {
    const { toasts } = this.state;

    return (
      <div className="toast-container">
        {toasts.map((toastItem) => (
          <Alert
            key={toastItem.id}
            variant={toastItem.type === 'success' ? 'success' : 'danger'}
            dismissible
            onClose={() => this.handleClose(toastItem.id)}
            className="toast-alert"
          >
            {toastItem.message}
          </Alert>
        ))}
      </div>
    );
  }
}

export default ToastContainer;




// WEBPACK FOOTER //
// ./src/components/common/ToastContainer.jsx